module.exports = __webpack_public_path__ + "media/steps/icon_2-5db14045.png";